import { render, staticRenderFns } from "./AgentAppointmentsTable.vue?vue&type=template&id=3012ea5a"
import script from "./AgentAppointmentsTable.vue?vue&type=script&lang=js"
export * from "./AgentAppointmentsTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports